import type { components } from '../../../generated/fct';
import { ApiError } from '../../shared';

export const CWF_DOCUMENT_TYPE_NAMES = {
  ADVANCE_HEART: 'DOCTYPE.ADVANCE.HEART',
  ADVANCE_NEURO: 'DOCTYPE.ADVANCE.NEURO',
  BLOOD_REPORT: 'DOCTYPE.BLOOD.REPORT',
  BODY_COMPOSITION: 'DOCTYPE.BODY.COMPOSITION',
  RADIOLOGY_REPORT: 'DOCTYPE.RADIOLOGY.REPORT',
} as const;

export type CwfDocumentTypeName =
  (typeof CWF_DOCUMENT_TYPE_NAMES)['BLOOD_REPORT'] | components['schemas']['CWFDocumentTypeEnum'];

export type CwfDocumentType = components['schemas']['DocumentType'];

export type CwfDocumentTypesResponse = CwfDocumentType[];

export type CwfDocumentTypesError = ApiError<unknown>;
